export interface EventTotals {
  services: number;
  test: number;
  travel: number;
  gross: number;
  discount: number;
  total: number;
}

const cents = (n: number) => Math.round(n * 100) / 100;

/**
 * Unico calcolo del totale evento (stessa regola del backend): servizi
 * selezionati + prova + trasferta, meno lo sconto. La percentuale si applica
 * alla trasferta solo se `include_travel`.
 */
export function eventTotals(event: any): EventTotals {
  const services = (event?.event?.services ?? [])
    .filter((s: any) => s.selected)
    .reduce((sum: number, s: any) => sum + (+s.price || 0) * (+s.quantity || 1), 0);
  const test = +event?.event?.test_cost || 0;
  const travel = +event?.financial?.travel_fee?.cost || 0;
  const gross = services + test + travel;

  const d = event?.financial?.discount;
  const value = Math.max(0, +d?.value || 0);
  const raw =
    d?.type === 'percent'
      ? ((services + test + (d?.include_travel ? travel : 0)) * Math.min(value, 100)) / 100
      : value;
  const discount = cents(Math.min(raw, gross));

  return {
    services: cents(services),
    test,
    travel,
    gross: cents(gross),
    discount,
    total: cents(gross - discount),
  };
}

export function emptyDiscount() {
  return { value: 0, type: 'fixed', label: '', include_travel: false };
}

/** Descrizione dell'utente, altrimenti l'etichetta di default; con la percentuale se serve. */
export function discountLabel(event: any, fallback: string): string {
  const d = event?.financial?.discount;
  const base = (d?.label ?? '').trim() || fallback;
  return d?.type === 'percent' ? `${base} (${+d.value || 0}%)` : base;
}
